import { useUISize } from 'app/utils/web-helpers';
import type { ComponentProps } from 'react';
import { CategoryPicker as CategoryPickerSmall } from './category-picker.small';
import { CategoryPicker as CategoryPickerLarge } from './category-picker.large';

export function CategoryPicker(props: ComponentProps<typeof CategoryPickerSmall>) {
  const { isSmallUI } = useUISize();
  if (isSmallUI) {
    return <CategoryPickerSmall {...props} />;
  }
  return <CategoryPickerLarge {...props} />;
}
